import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ApiHttpService } from 'src/app/core/services/apiHttpcall.service';
import { Response } from 'src/app/shared/interfaces/response';

interface Reason {
  id: number;
  name: string;
}
@Component({
  selector: 'reason-dialog',
  templateUrl: './reason-dialog.component.html',
  styleUrls: ['./reason-dialog.component.scss']
})
export class ReasonDialogComponent {
  @Input('appendTo') appendTo: string;
  show_Dialog: boolean = false;
  id:number;
  is_text: boolean = false;
  text: string = '';
  data: any[] = [];
  rejectForm: FormGroup;
  is_form_submit: boolean = false;
  isLoading: boolean = false;
  status:number = 7;
  title = 'Reason';
  isReason: boolean = false;

  reasons: Reason[] = [];

  @Output() onSuccess: EventEmitter<any> = new EventEmitter();

  @HostListener('document:keydown.escape', ['$event'])
  onEscPressed(event: KeyboardEvent) {
    this.hide();
  }

  constructor(
    public readonly dialogService: DialogService,
    private readonly fb: FormBuilder,
    private readonly httpService: ApiHttpService,
    private readonly messageService: MessageService,
    private readonly confirmationService: ConfirmationService,
    private readonly ngxSpinnerService: NgxSpinnerService
  ) { }

  // cancel upload
  uploadCancel() {

  }

  initializeForm() {
    this.rejectForm = this.fb.group({
      reason: [null, Validators.compose([Validators.required])],
      comment: ['', Validators.compose([Validators.maxLength(50)])],
    });
  }

  // cancel popup 
  cancel() {
    this.dialogService.dialogComponentRefMap.forEach(dialog => {
      dialog.destroy();
    });
  }

  show() {
    this.show_Dialog = true;
    console.log(this.text, "From dialog is");
    this.fetchResons();
    if(!this.is_text){
      this.initializeForm();
    }
  }

  setIsText(value: boolean) {
    this.is_text = value;
  }

  hide() {
    this.is_form_submit = false;
    this.show_Dialog = false;
  }

  async handleSubmitForm() {
    this.is_form_submit = true;
    // reason
    if (this.isReason) {
      let reason = this.rejectForm.controls['reason'].value;
      this.onSuccess.emit(reason); 
      this.is_form_submit = false;
      this.hide();
    } else { // reject
      if (this.rejectForm.valid) {
        this.isLoading = true;
        // status=${this.status}&reason=${this.rejectForm.controls['reason'].value}
        let resp = await this.httpService.put(`/trip/${this.id}/update-status`, null, {
          params: {
            status: this.status,
            reason_id: this.rejectForm.get('reason')?.value,
            reason: this.rejectForm.get('comment')?.value,
          }
        });
        
        if (resp?.status == 200) {
          this.onSuccess.emit();
          this.is_form_submit = false;
          this.hide();
          this.messageService.add({ severity: 'customSuccess', 
          icon: 'i-check-circle', 
          summary: 'Success', 
          detail: 'Status updated successfully', 
          key: 'app_notiy' });
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: resp?.error?.message, key: 'app_notiy' });
      }
      this.isLoading = false;
    }
  }
  }

  async fetchResons() {
    this.ngxSpinnerService.show();
    // TODO: enter correct endpoint for the reasons
    const resp = await this.httpService.get<Response<any>>('/reasons/lookup');
    // stop loading spinner
    if(resp) this.ngxSpinnerService.hide();
    if(resp.status == 200) {
      this.reasons = resp.data;
    }
  }

  handleCancelConfirm() {
    if (this.rejectForm.controls['reason'].value) {
      this.confirmationService.confirm({
        message: 'All the saved data will be lost. Are you sure?',
        header: 'Cancel',
        icon: 'i-warn',
        acceptLabel: 'Yes',
        rejectLabel: 'No',
        accept: () => {
          this.hide();
        },
      });
    }
    else {
      this.hide();
    }

  }
}
